import React from 'react';

export default function OrderBookingTable({ data, showShadow = true }) {
  return (
    <div
      data-testid={'custom-order-booking-table'}
      style={{
        width: '100%',
        borderRadius: 5,
        overflow: 'hidden',
        marginTop: 30,
        boxShadow: showShadow
          ? 'rgba(100, 100, 111, 0.2) 0px 7px 29px 0px'
          : 'none',
      }}
    >
      <div className='ledger_table-row' style={{ backgroundColor: 'white' }}>
        {data.rows.map((row) => {
          if (row === 'donotshow') return '';
          return <h5 className='ledger_table-title'>{row}</h5>;
        })}
      </div>
      {data.tableData.map((item, index) => {
        return (
          <div
            onClick={(e) => {
              data.onRowClick(index);
            }}
            className='ledger_table-row'
            style={{
              backgroundColor: index % 2 !== 0 ? '#fdecdb' : '#fffaf0',
              cursor: 'pointer',
            }}
          >
            {item.map((i) => {
              if (i === 'donotshow') return '';
              return <h5 className='ledger_table-subTitle'>{i}</h5>;
            })}
          </div>
        );
      })}
      {/* <div
        className='ledger_table-row'
        style={{
          backgroundColor: '#fff',
        }}
      >
        <h5 className='ledger_table-subTitle'>Total</h5>
        <h5 className='ledger_table-subTitle'>totalMT</h5>

        <h5 className='ledger_table-subTitle'>dispatchedQty</h5>
        <h5 className='ledger_table-subTitle'>totalCost + totaltax</h5>
      </div> */}
    </div>
  );
}
